export function initStockSearch() {
  const searchInput = document.getElementById('stock-search-input');
  const resultsContainer = document.querySelector('#stock-search-results tbody');
  if (!searchInput || !resultsContainer) return;

  let products = [];
  
  // Fetch products data
  fetch('/products.json?v=' + Date.now())
    .then(res => res.json())
    .then(data => {
      products = data;
    })
    .catch(err => {
      console.error("Failed to load products list:", err);
      resultsContainer.innerHTML = '<tr class="search-empty"><td colspan="5">Sorry, the stock list could not be loaded at this time.</td></tr>';
    });

  let timeout = null;

  // --- Quote Builder Logic ---
  let quote = [];
  try {
    quote = JSON.parse(localStorage.getItem('artonmain_quote') || '[]');
  } catch(e) {
    quote = [];
  }
  
  const quoteContainer = document.getElementById('quote-items-container');
  const quoteTotalEl = document.getElementById('quote-total-amount');
  const btnDownloadCsv = document.getElementById('btn-download-csv');
  const btnPrintQuote = document.getElementById('btn-print-quote');
  const btnWhatsappQuote = document.getElementById('btn-whatsapp-quote');

  function saveQuote() {
    localStorage.setItem('artonmain_quote', JSON.stringify(quote));
    renderQuote();
  }

  function addToQuote(product) {
    if (product.price <= 0) return; // Can't add POR items easily without a price, but let's allow it with 0 price if they want
    const existing = quote.find(item => item.code === product.code);
    if (existing) {
      existing.qty += 1;
    } else {
      quote.push({
        code: product.code,
        description: product.description,
        price: product.price,
        qty: 1
      });
    }
    saveQuote();
  }

  function renderQuote() {
    if (!quoteContainer || !quoteTotalEl) return;
    
    if (quote.length === 0) {
      quoteContainer.innerHTML = '<p class="quote-empty">Your Quote Request is empty. Search and add items to build a request.</p>';
      quoteTotalEl.innerText = 'R0.00';
      if (btnDownloadCsv) btnDownloadCsv.disabled = true;
      if (btnPrintQuote) btnPrintQuote.disabled = true;
      if (btnWhatsappQuote) btnWhatsappQuote.disabled = true;
      return;
    } else {
      if (btnDownloadCsv) btnDownloadCsv.disabled = false;
      if (btnPrintQuote) btnPrintQuote.disabled = false;
      if (btnWhatsappQuote) btnWhatsappQuote.disabled = false;
    }
    
    let html = '';
    let total = 0;
    
    quote.forEach((item, index) => {
      const itemTotal = item.price * item.qty;
      total += itemTotal;
      html += `
        <div class="quote-item">
          <div class="quote-item-details">
            <div class="quote-item-desc">${escapeHtml(item.description)}</div>
            <div class="quote-item-price">R${item.price.toFixed(2)} x ${item.qty}</div>
          </div>
          <div class="quote-item-actions">
            <input type="number" min="1" class="quote-qty" data-index="${index}" value="${item.qty}">
            <button class="btn-remove" data-index="${index}" aria-label="Remove item">&times;</button>
          </div>
        </div>
      `;
    });
    
    quoteContainer.innerHTML = html;
    quoteTotalEl.innerText = `R${total.toFixed(2)}`;
  }

  if (quoteContainer) {
    quoteContainer.addEventListener('change', (e) => {
      if (e.target.classList.contains('quote-qty')) {
        const index = parseInt(e.target.getAttribute('data-index'));
        const newQty = parseInt(e.target.value);
        if (newQty > 0) {
          quote[index].qty = newQty;
          saveQuote();
        }
      }
    });

    quoteContainer.addEventListener('click', (e) => {
      if (e.target.classList.contains('btn-remove')) {
        const index = parseInt(e.target.getAttribute('data-index'));
        quote.splice(index, 1);
        saveQuote();
      }
    });
  }
  
  const btnClearQuote = document.getElementById('btn-clear-quote');
  if (btnClearQuote) {
    btnClearQuote.addEventListener('click', () => {
      if (quote.length > 0 && confirm('Are you sure you want to clear your Quote Request?')) {
        quote = [];
        saveQuote();
      }
    });
  }

  if (btnDownloadCsv) {
    btnDownloadCsv.addEventListener('click', () => {
      if (quote.length === 0) return;
      let csvContent = "Code,Description,Price,Quantity,Total\n";
      let grandTotal = 0;
      quote.forEach(item => {
        const total = item.price * item.qty;
        grandTotal += total;
        const desc = `"${item.description.replace(/"/g, '""')}"`;
        csvContent += `${item.code},${desc},${item.price.toFixed(2)},${item.qty},${total.toFixed(2)}\n`;
      });
      csvContent += `,,,Grand Total,${grandTotal.toFixed(2)}\n`;
      
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "ArtOnMain_QuoteRequest.csv");
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }

  if (btnPrintQuote) {
    btnPrintQuote.addEventListener('click', () => {
      if (quote.length === 0) return;
      
      const printWindow = window.open('', '_blank');
      let html = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Art on Main - Quote Request</title>
          <style>
            body { font-family: sans-serif; padding: 40px; color: #333; }
            h1 { color: #d82b3a; border-bottom: 2px solid #eee; padding-bottom: 10px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { padding: 10px; border-bottom: 1px solid #ddd; text-align: left; }
            th { background: #f9f9f9; }
            th.right, td.right { text-align: right; }
            .total { font-size: 20px; font-weight: bold; text-align: right; margin-top: 20px; padding-top: 10px; border-top: 2px solid #333; }
            .header-info { margin-bottom: 30px; font-size: 14px; color: #555; }
          </style>
        </head>
        <body>
          <h1>Art on Main - Quote Request</h1>
          <div class="header-info">
            <p>Shop 20, Walmer Park Shopping Centre, Main Road, Walmer, Gqeberha, 6070</p>
            <p>Email: cedric@artonmain.co.za | Phone/WhatsApp: 082 367 6722</p>
            <p>Date: ${new Date().toLocaleDateString()}</p>
          </div>
          <table>
            <thead>
              <tr>
                <th>Code</th>
                <th>Description</th>
                <th class="right">Price</th>
                <th class="right">Qty</th>
                <th class="right">Total</th>
              </tr>
            </thead>
            <tbody>
      `;
      
      let grandTotal = 0;
      quote.forEach(item => {
        const itemTotal = item.price * item.qty;
        grandTotal += itemTotal;
        html += `
          <tr>
            <td>${escapeHtml(item.code)}</td>
            <td>${escapeHtml(item.description)}</td>
            <td class="right">R${item.price.toFixed(2)}</td>
            <td class="right">${item.qty}</td>
            <td class="right">R${itemTotal.toFixed(2)}</td>
          </tr>
        `;
      });
      
      html += `
            </tbody>
          </table>
          <div class="total">Grand Total: R${grandTotal.toFixed(2)}</div>
          <script>
            window.onload = function() { window.print(); }
          </script>
        </body>
        </html>
      `;
      
      printWindow.document.write(html);
      printWindow.document.close();
    });
  }

  if (btnWhatsappQuote) {
    btnWhatsappQuote.addEventListener('click', () => {
      if (quote.length === 0) return;
      
      const phone = btnWhatsappQuote.getAttribute('data-number');
      if (!phone) return;

      let msg = "Hi Art on Main, I have a Quote Request for the following items:\n\n";
      let grandTotal = 0;
      
      quote.forEach(item => {
        const itemTotal = item.price * item.qty;
        grandTotal += itemTotal;
        msg += `• ${item.qty}x ${item.description} (Code: ${item.code}) - R${itemTotal.toFixed(2)}\n`;
      });
      
      msg += `\n*Grand Total: R${grandTotal.toFixed(2)}*\n\nThank you!`;
      
      const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
      window.open(whatsappUrl, '_blank');
    });
  }

  // Initial render
  renderQuote();
  
  // --- Search Logic ---
  
  resultsContainer.addEventListener('click', (e) => {
    if (e.target.classList.contains('btn-add-quote')) {
      const code = e.target.getAttribute('data-code');
      const product = products.find(p => p.code === code);
      if (product) {
        addToQuote(product);
      }
    }
  });

  searchInput.addEventListener('input', (e) => {
    clearTimeout(timeout);
    const query = e.target.value.toLowerCase().trim();
    
    if (query.length < 2) {
      resultsContainer.innerHTML = '<tr class="search-empty"><td colspan="5">Start typing to search our stock list...</td></tr>';
      return;
    }

    // Debounce search slightly
    timeout = setTimeout(() => {
      // Fuzzy search: split query into terms and ensure all terms are found in the product text
      const terms = query.split(/\s+/);
      
      let matches = products.filter(p => {
        const text = `${p.code} ${p.description} ${p.category}`.toLowerCase();
        return terms.every(term => text.includes(term));
      });

      renderResults(matches, query);
    }, 150);
  });

  function renderResults(matches, query) {
    if (matches.length === 0) {
      resultsContainer.innerHTML = `<tr class="search-empty"><td colspan="5">No products found matching "${query}". Ask us to order it!</td></tr>`;
      return;
    }

    let html = matches.map(p => {
      const priceStr = p.price > 0 ? `R${p.price.toFixed(2)}` : 'POR';
      let stockStr;
      if (p.onhand > 0) {
        stockStr = 'In Stock';
      } else if (p.reorder > 0) {
        stockStr = 'Restocking Soon';
      } else {
        stockStr = 'Out of stock';
      }
      return `
      <tr class="search-result-item">
        <td class="result-cat">${escapeHtml(p.category)}</td>
        <td class="result-desc">${escapeHtml(p.description)}</td>
        <td class="result-code">${escapeHtml(p.code)}</td>
        <td class="result-stock">${stockStr}</td>
        <td class="result-price">${priceStr}</td>
        <td class="result-action">
          <button class="btn-add-quote" data-code="${escapeHtml(p.code)}">+ Add</button>
        </td>
      </tr>
      `;
    }).join('');
    
    resultsContainer.innerHTML = html;
  }

  function escapeHtml(unsafe) {
    return (unsafe || '').replace(/[&<"'>]/g, function (m) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[m];
    });
  }
}
